
export default {
    props:{
        cart:{default:{}}
    },
    methods:{
    },
}
